import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { LoginStorage } from './../../login/login.storage';
import { LoaderService } from './../../shared/loader/loader.service';
import { HttpClient } from '@angular/common/http';
import { OmniRestService } from '../omni-rest.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../shared/loader/loader.service";
import * as i3 from "../../login/login.storage";
import * as i4 from "@angular/router";
export class OmniGiroMaisRecusadaRestService extends OmniRestService {
    constructor(http, loaderService, loginStorage, router) {
        super(http, loaderService, loginStorage, router);
    }
    getBaseUrl() {
        return environment.URL_RODAS;
    }
    getHeaders() {
        return {
            'Content-Type': 'application/json',
            'omni-autenticacao': this.loginStorage.loginAndTokenAsJson,
        };
    }
}
OmniGiroMaisRecusadaRestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OmniGiroMaisRecusadaRestService_Factory() { return new OmniGiroMaisRecusadaRestService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoaderService), i0.ɵɵinject(i3.LoginStorage), i0.ɵɵinject(i4.Router)); }, token: OmniGiroMaisRecusadaRestService, providedIn: "root" });
